import React from "react";
import SEO from "../components/SEO";
import Hero from "../components/sections/Hero";
import SoftOpeningBanner from "../components/sections/SoftOpeningBanner";
import TrustBar from "../components/sections/TrustBar";
import FeaturedProducts from "../components/sections/FeaturedProducts";
import FeaturedBrands from "../components/sections/FeaturedBrands";
import LocationsHub from "../components/sections/LocationsHub";
import MedicalAccess from "../components/sections/MedicalAccess";
import HowToBuy from "../components/sections/HowToBuy";
import FeaturedContent from "../components/sections/FeaturedContent";
import TrustAuthority from "../components/sections/TrustAuthority";
import Testimonials from "../components/sections/Testimonials";
import FAQSection from "../components/sections/FAQSection";
import SEOLongform from "../components/sections/SEOLongform";
import DispensaryInfo from "../components/sections/DispensaryInfo";

export default function Home() {
  return (
    <>
      <SEO
        title="District Wellness Center | Medical Cannabis in Washington, DC"
        description="Trusted medical cannabis dispensary in Washington DC 20011 — 4915 Georgia Ave NW, Petworth. Premium flower, edibles, vapes, concentrates. Walk-ins welcome · same-day delivery."
        path="/"
      />
      <Hero />
      <SoftOpeningBanner />
      <TrustBar />
      <MedicalAccess />
      <FeaturedProducts />
      <FeaturedBrands />
      <LocationsHub />
      <HowToBuy />
      <FeaturedContent />
      <TrustAuthority />
      <Testimonials />
      <FAQSection heading="Frequently asked questions." limit={6} />
      <SEOLongform />
      <DispensaryInfo />
    </>
  );
}
